// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__N7wMr","footer":"ModalInfo_footer__1HPzy"};